import * as React from "react";
import styled, { css } from "styled-components";
import { Icon } from "components/common";
const Container = styled.div(
  ({ theme }) => css`
    display: inline-flex;
    align-items: center;
    justify-content: center;

    height: 30px;
    width: 30px;

    border-radius: 50%;
    background-color: ${theme.colors.gray[80]};
  `
);
const _iconName = (type) => {
  switch (type) {
    case "global":
      return "apartment";
    case "team":
      return "group";
    case "error":
      return "error";
    case "user":
    default:
      return "person";
  }
};
const GranteeIcon = ({ type, ...rest }) => /* @__PURE__ */ React.createElement(Container, { ...rest }, /* @__PURE__ */ React.createElement(Icon, { name: _iconName(type) }));
export default GranteeIcon;
